module.exports = __webpack_public_path__ + "img/hr-rock-big-06.c98152db.png";